var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.variant === 'primary' || _vm.variant === 'secondary'
      ? ("btn-" + _vm.variant)
      : _vm.variant,style:(_vm.noLeftPadding ? 'padding-left: 4px;' : ''),attrs:{"type":"button","disabled":_vm.disabled},on:{"mouseover":function($event){return _vm.onMouseOver()},"mouseout":function($event){return _vm.onMouseOut()},"click":_vm.action}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }